import { ITeamRole } from "models/IProjectIQWorkspace";

export const DEFAULT_TEAM_ROLES: ITeamRole[] = [
  {
    id: "default-client-executive",
    name: "Client Executive",
    responsibilities: [
      "Serve as executive sponsor and primary decision-maker for the engagement",
      "Provide strategic direction and remove executive-level obstacles",
      "Approve investment decisions and major scope changes",
      "Maintain accountability for overall engagement outcomes with senior leadership",
      "Champion the engagement and North Highland partnership within the client organization",
    ],
    assignedMember: "Unassigned",
    isDefault: true,
  },
  {
    id: "default-client-lead",
    name: "Client Lead",
    responsibilities: [
      "Act as primary day-to-day client point of contact for the project team",
      "Own business decisions and drive stakeholder alignment on the client side",
      "Facilitate access to subject matter experts, data, and systems",
      "Review and approve deliverables from the business perspective",
      "Escalate blockers and decisions to the Client Executive as needed",
    ],
    assignedMember: "Unassigned",
    isDefault: true,
  },
  {
    id: "default-engagement-leader",
    name: "Engagement Leader",
    responsibilities: [
      "Own overall delivery accountability and quality on behalf of North Highland",
      "Lead team coordination, scope management, and risk mitigation",
      "Enforce North Highland Delivery Excellence standards throughout the engagement",
      "Serve as primary escalation point for the project team",
      "Manage and strengthen the client relationship alongside the Client Lead",
    ],
    assignedMember: "Unassigned",
    isDefault: true,
  },
];
